<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title class="title pt-5 pb-0">
        Pagamento Recusado
      </v-card-title>

      <v-card-text class="pt-2 pb-9">
        <p class="mb-0">
          Não conseguimos processar o pagamento desta vez.
          <br><br>
          <strong>Motivo:</strong> {{ motivo }}
          <br><br>
          Para garantir que sua assinatura continue ativa, tente utilizar outra forma de pagamento.
        </p>
      </v-card-text>

      <v-card-actions class="pt-9">
        <v-spacer />
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          Fechar
        </v-btn>

        <v-btn
          color="primary"
          text
          @click="tentarNovamente"
        >
          Tentar com outro Cartão
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ModalPagamentoRecusado',
  props: {
    value: Boolean,
    motivo: {
      type: String,
      default: '',
    },
    compraId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    ...mapActions('meuperfil', ['setAssinaturaCadastrarCartao']),

    tentarNovamente() {
      this.setAssinaturaCadastrarCartao(true);
      this.$router.push('/meu-perfil/cartoes-credito/cadastrar');
      this.dialog = false;
    },
  },
};
</script>
